import { persistentStorage } from "@/utils";

const IS_JUST_LOGGED_IN_KEY = "_is_just_logged_in_";

export async function setJustLoggedIn(): Promise<void> {
  await persistentStorage.setItem(IS_JUST_LOGGED_IN_KEY, new Date().toString());
}

const valP = persistentStorage.getItem(IS_JUST_LOGGED_IN_KEY);

// eslint-disable-next-line no-restricted-syntax,promise/prefer-await-to-then
void valP.then((val) => {
  if (val) {
    void persistentStorage.removeItem(IS_JUST_LOGGED_IN_KEY);
  }
});

/**
 * the callback will be executed if we just logged in, otherwise, it will not be executed;
 */
export function ifJustLoggedIn(cb: () => void): void {
  // eslint-disable-next-line no-restricted-syntax,promise/prefer-await-to-then
  void valP.then((val) => {
    if (typeof val !== "string") return;
    if (val.length < 5) return;
    const d = new Date(val);
    if (d.getFullYear() < 2021) return;
    const msPassed = new Date().getTime() - d.getTime();
    const passedVeryRecently = msPassed < 20000;
    if (passedVeryRecently) {
      cb();
    }
  });
}
